import React, { useState } from 'react';

const getPainTypeClasses = (type) => {
  const baseClasses = "text-sm font-bold px-2 py-1 rounded-md";
  let colorClasses = "";

  switch (type.toLowerCase()) {
    case 'functionality':
      colorClasses = "bg-red-100 text-red-800 dark:bg-red-800/50 dark:text-red-200";
      break;
    case 'usability':
      colorClasses = "bg-yellow-100 text-yellow-800 dark:bg-yellow-800/50 dark:text-yellow-200";
      break;
    case 'integration':
      colorClasses = "bg-purple-100 text-purple-800 dark:bg-purple-800/50 dark:text-purple-200";
      break;
    case 'cost':
      colorClasses = "bg-green-100 text-green-800 dark:bg-green-800/50 dark:text-green-200";
      break;
    default:
      colorClasses = "bg-blue-100 text-blue-800 dark:bg-blue-800/50 dark:text-blue-200";
  }
  return `${baseClasses} ${colorClasses}`;
};

const PainResultsCard = ({ pains }) => {
  const [expandedPainIndex, setExpandedPainIndex] = useState(null);

  const handleTogglePain = (index) => {
    setExpandedPainIndex(prev => (prev === index ? null : index));
  };

  if (!pains || pains.length === 0) {
    return (
      <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl border border-blue-200 dark:border-blue-800">
        <p className="text-blue-700 dark:text-blue-300">No pains were identified in this post.</p>
      </div>
    );
  }

  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl border border-blue-200 dark:border-blue-800" data-testid="painResultsCard-container">
      <div className="flex items-center gap-3 mb-4">
        <span className="material-symbols-outlined text-blue-600 dark:text-blue-400">psychology</span>
        <h3 className="font-semibold text-text-light-primary dark:text-text-dark-primary text-lg">Extracted Pain Points</h3>
      </div>
      <div className="space-y-4">
        {pains.map((pain, index) => {
          const isPainExpanded = expandedPainIndex === index;
          return (
            <div key={index} className="p-4 rounded-lg border border-blue-200 dark:border-blue-800 bg-container-light dark:bg-container-dark">
              <div className="relative">
                <div className="flex-1">
                  <div className="flex justify-between items-start mb-2">
                    <span className={getPainTypeClasses(pain.type)} data-testid="painResultsCard-painTypeBadge">
                      {pain.type}
                    </span>
                    <span className="text-sm text-text-light-secondary dark:text-text-dark-secondary">
                      Confidence: {Math.round(pain.confidence * 100)}%
                    </span>
                  </div>
                  <p className={`text-text-light-primary dark:text-text-dark-primary font-medium my-2 ${!isPainExpanded ? 'line-clamp-3' : ''}`}>
                    {pain.pain_statement}
                  </p>
                  {isPainExpanded && (
                    <>
                      <p className="text-sm text-text-light-secondary dark:text-text-dark-secondary italic border-l-2 border-blue-300 pl-3 my-3">
                        <strong className="font-semibold">Citation:</strong> "{pain.citation}"
                      </p>
                      <p className="text-sm text-text-light-secondary dark:text-text-dark-secondary">
                        <strong className="font-semibold">Root Cause:</strong> {pain.root_cause}
                      </p>
                      <div className="flex flex-wrap gap-2 mt-3">
                          <span className="text-xs font-medium bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200 px-2 py-1 rounded-full">Asks for help: {pain.asks_for_help}</span>
                          <span className="text-xs font-medium bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200 px-2 py-1 rounded-full">Lacks solution: {pain.lacks_solution}</span>
                          <span className="text-xs font-medium bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200 px-2 py-1 rounded-full">Intensity: {pain.intensity}</span>
                      </div>
                    </>
                  )}
                </div>
                <button onClick={() => handleTogglePain(index)} className="absolute bottom-0 right-0 bg-transparent !bg-transparent text-[var(--color-primary-accent)] hover:bg-transparent !hover:bg-transparent transition-none flex-shrink-0 p-1 min-w-[unset] min-h-[unset] border-none outline-none" data-testid="painResultsCard-expandCollapseButton">
                  <span className="material-symbols-outlined text-xl">
                    {isPainExpanded ? 'expand_less' : 'expand_more'}
                  </span>
                </button>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default PainResultsCard;
